// © Microsoft Corporation. All rights reserved.

/**
 * Callback interface used by all bridge calls.
 * @param result Response in string returned by sapphire. If no response, return empty string.
 */
export interface SapphireBridgeCallBackFunction {
    (result: string): void;
}
/**
 * The interface for user configuration.
 */
export interface UserConfig {
    muid?: string;
    anid?: string;
    adid?: string; // Advertisement id
    sapphireId?: string;
    market?: string;
    latitude?: string;
    longitude?: string;
    accountType?: string;
    isSignedIn?: boolean;
    features?: string;
    activityId?: string;
    isDarkMode?: boolean;
    isPageRefresh?: boolean;
    platform?: DevicePlatform;
    bridgeVersionInt?: number;
    language?: string;
    countryCode?: string;
    fontSize?: number;
    isEos?: boolean;
    isChinaBuild?: boolean
}

/**
 * The interface for user information.
 */
export interface UserInformation {
    accountType?: string;
    accessToken?: string; // Access token is only present for AAD
    avatarData?: string;
    avatarUrl?: string;
    displayName?: string;
    isActive?: boolean;
    isAADUsed?: boolean;
    isMSAUsed?: boolean;
    isSignedIn?: boolean;
    userEmail?: string;
    userGivenName?: string;
    userId?: string;
    userLastName?: string;
}

/**
 * The interface for device information.
 */
export interface DeviceInformation {
    ADID?: string;
    ANID?: string;
    appName?: string;
    bucket?: string;
    capabilities?: string;
    clientVersion?: string;
    country?: string;
    detectedCountry?: string;
    expActivityId?: string;
    expFeatures?: string;
    isAutoTestMode?: boolean;
    isBingApp?: boolean;
    isDarkMode?: boolean;
    isDebugMode?: boolean;
    isNewsApp?: boolean;
    market?: string;
    modelName?: string;
    orientation?: string;
    osBuild?: string;
    osVersion?: string;
    packageName?: string;
    platform?: DevicePlatform;
    sapphireId?: string;
    screenHeight?: number;
    screenWidth?: number;
    sessionId?: string;
    speechLanguage?: string;
    statusBarHeight?: number;
    userAgent?: string;
    bridgeVersion?: string;
    bridgeVersionInt?: number;
    fontSize?: number;
    isDaily?: boolean;
    isDogfood?: boolean;
    isProd?: boolean;
    isTablet?: boolean;
    isEos?: boolean;
    isChinaBuild?: boolean;
}

/**
 * Sapphire device platform.
 */
export enum DevicePlatform {
    Android = "Android",
    iOS = "iOS"
}